import { ScanSearch, ToggleRight, Code2, RefreshCw } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: ScanSearch,
    title: "Scan",
    body: "We run an automated scan of your site and hand you a plain-English report with a score. Free, no strings.",
  },
  {
    n: "02",
    icon: ToggleRight,
    title: "Install the toolbar",
    body: "One line of code adds an accessibility toolbar — 132 languages, read-aloud, one-tap profiles for 9 needs.",
  },
  {
    n: "03",
    icon: Code2,
    title: "Provide the code fixes",
    body: "Real fixes for real barriers: missing alt text, form labels, headings, focus styles and skip links. Not just a widget.",
  },
  {
    n: "04",
    icon: RefreshCw,
    title: "Keep checking",
    body: "Scheduled monthly rescans (up to 1,000 pages) track your score over time and flag new issues as your site changes.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>FOUR STEPS</Eyebrow>
        <h2 className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white">
          FROM EXPOSED TO <span className="text-safe">PROTECTED.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08} className="h-full">
            <div className="group relative h-full rounded-2xl border border-white/10 bg-panel p-6 sm:p-7 transition-all hover:border-brandamber/50 hover:-translate-y-1">
              <span className="font-mono text-xs text-slate-600">{s.n}</span>
              <s.icon className="mt-4 h-9 w-9 text-brandamber transition-transform group-hover:scale-110" />
              <h3 className="mt-5 text-lg font-semibold text-white">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
